import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import { Button, Col, Input, message, Modal, Row, Select } from "antd";
import { useCallback, useContext, useEffect, useState } from "react";
import AwsServerService from "../../../common/util/AwsServerService";
import { useDispatch, useSelector } from "react-redux";
import { RoleUserPicker } from "../../Roles/RoleUserPicker";
import HierarchicalDropdown from "../../Roles/HierarchicalDropdown";
import "./RoleSelectionForAccount.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt, faTrash } from "@fortawesome/free-solid-svg-icons";
import { AppDataRequired } from "../../../App";
import ModuleService from "../../../common/util/ModuleService";
import { setModuleContacts } from "../../../Context/ReduxContext";
import AppContext from "../../../Context/AppContext"
export default function RoleSelectionForAccount(props) {
  let location = useLocation();
  const reduxDispatch = useDispatch();  
  const { AllUsers } = useContext(AppDataRequired);
  const AppData = useContext(AppContext);
  const { state, dispatch } = AppData || {};
  const allAccounts = state.AllAccounts || [];
  const isEdit =
    location.state.action == "Update" &&
    (location.state.module == "Accounts" || location.state.module == "Deals");
  const AllDeals = useSelector((state) => state.AppReduxContext.AllDeals);
  const [allContacts, setAllContacts] = useState({})
  // const moduleContacts = useSelector(
  //   (state) => state.AppReduxContext.moduleContacts,
  // );
  const [UserType] = useState("Account");
  const [userListModules, setUserListModule] = useState(["Account", "Other"]);
  const [searchValue1, setSearchValue1] = useState("");
  const [ModuleData, setModuleData] = useState([]);
  const [DealChange, setDealChange] = useState("");
  const [clearSearchValue, setclearSearchValue] = useState(false);
  const [accountRoleList, setAccountRoleList] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [refreshRoles, setRefreshRoles] = useState(false);
  let externalUserList = ["Accounts", "Vendors", "Contacts"];
  let TypeOpDropdown = "Deal";
  const [ErrorStatus, setErrorStatus] = useState({
    roleTypeError: "",
    roleError: "",
    userError: "",
    DealAndClientError: "",
  });
  useEffect(() => {
    setAccountRoleList(props.roles || []);
    getContactsByModule();
  }, [props.roles]);
  const [projectRoleObject, setprojectRoleObject] = useState({
    RoleId: "",
    UserId: "",
    UserType: "",
    RoleName: "",
    UserName: "",
    ROWID: "",
  });

  useEffect(() => {
    localStorage.setItem(
      "accountDealDefaultRoleList",
      JSON.stringify(accountRoleList),
    );
  }, [accountRoleList]);

  useEffect(() => {
    if (ModuleData.length === 0) {
      const fetchModules = async () => {
        try {
          const res = await AwsServerService.CrudServiceHandler({
            method: "GET",
            data: "",
            route: "MODULES",
          });
          const ModulesData = res.data.map((item) => ({
            ModuleDisplayName: item?.ModuleDisplayName,
            ModuleApiName: item?.ModuleApiName,
            ApiPrimaryField: item?.ApiPrimaryField,
            ApiNameField: item?.ApiNameField,
          }));
          externalUserList = [];
          ModulesData.map((item) =>
            externalUserList.push(item?.ModuleDisplayName),
          );
          // Set the ModuleData state
          setModuleData(ModulesData);
        } catch (error) {
          console.error("Error fetching modules:", error);
        }
      };

      fetchModules();
    }
  }, [userListModules, ModuleData]);

  const onRoleChange = (value, option) => {
    setErrorStatus({});
    let obj = { ...projectRoleObject };
    if (value) {
      obj["RoleId"] = value.split("_")[1];
      obj["RoleName"] = option.label;
    } else {
      obj["RoleId"] = "";
      obj["RoleName"] = "";
    }
    setprojectRoleObject(obj);
  };

  const onDealChange = (value, option) => {
    setErrorStatus({});
    let obj = { ...projectRoleObject };
    if (value) {
      obj["ProjectId"] = value;
    } else {
      obj["ProjectId"] = "";
    }
    setDealChange(value);
    setprojectRoleObject(obj);
  };

  const onUserChange = (value, option) => {
    let obj = { ...projectRoleObject };
    obj["UserId"] = value;
    obj["UserType"] = UserType;
    obj["UserName"] = option[0];
    setprojectRoleObject(obj);
    setclearSearchValue(true);
  };

  const getAssociatDropdown = useCallback(() => {debugger
    if (UserType !== "Deal") {
      return Object.keys(allContacts || {})
        .flatMap((Type) =>
          (allContacts[Type] || [])
            .filter((subgroupData) => Type === UserType) // Filter matching UserType
            .map((subgroupData) => {
              const subgroupKey = subgroupData[`${Type}_Name`]?.id;
              const isTypeNamePresent =
                subgroupData[`${Type}_Name`]?.name || "Unknown";
              return subgroupKey ? (
                <Select.Option key={subgroupKey} value={subgroupKey}>
                  {isTypeNamePresent}
                </Select.Option>
              ) : null; // Prevent rendering invalid options
            }),
        )
        .filter(Boolean); // Remove null values
    } else {
      return AllDeals?.map((subgroupData) => {
        const subgroupKey = subgroupData["Deal_Name"];
        const isTypeNamePresent = subgroupData["Deal_Name"] || "Unknown";
        return subgroupKey ? (
          <Select.Option key={subgroupKey} value={subgroupKey}>
            {isTypeNamePresent}
          </Select.Option>
        ) : null;
      }).filter(Boolean); // Remove null values
    }
  }, [UserType, allContacts, AllDeals]);

  const ClearAllData = () => {
    setUserListModule(["Account", "Other"]);
    // setUserType(null);
    setprojectRoleObject({
      RoleId: "",
      UserId: "",
      UserType: "",
      RoleName: "",
      UserName: "",
      ROWID: "",
    });
    setEditIndex(null);
  };

  const onAdd = () => {
    debugger;
    const roleObject = { ...projectRoleObject };

    if (roleObject.RoleId && roleObject.UserId && roleObject.UserType) {
      if (isEdit) {
        handleApiCall(roleObject);
      }
      setAccountRoleList((prev) => {
        const next = [...prev, roleObject];
        if (props.module === "deal") {
          props.setRoles(next);
        }
        return next;
      });
      setUserListModule(["Account", "Other"]);
      // setUserType(null);
      setprojectRoleObject({
        RoleId: "",
        UserId: "",
        UserType: "",
        RoleName: "",
        UserName: "",
        ROWID: "",
      });
    }
  };

  const handleApiCall = async (data) => {
    const payload = {
      RoleId: data["RoleId"],
      UserId: data["UserId"],
      ProjectId: data["ProjectId"] || props.projectId,
      UserType: data["UserType"],
    };

    if (isEdit && data["ROWID"]) {
      payload["ROWID"] = data["ROWID"];
    }

    AwsServerService.CrudServiceHandler({
      method: isEdit && data["ROWID"] ? "PUT" : "POST",
      data: payload,
      route: "USERROLES",
    })
      .then((res) => {
        if (res) {
          localStorage.removeItem("accountDealDefaultRoleList");
          if (isEdit) {
            message.success("Role Updated Successfully !");
          } else {
            message.success("Role Added Successfully !");
          }

          setAccountRoleList((prev) => {
            let updated;

            if (isEdit && data["ROWID"]) {
              updated = prev.map((item) =>
                item.ROWID === data.ROWID ? { ...item, ...data } : item,
              );
            } else {
              const newItem = {
                ...data,
                ROWID: res?.data?.insertId,
              };

              updated = [...prev, newItem];
            }

            if (props.module === "deal") {
              props.setRoles(updated);
            }

            return updated;
          });
          setUserListModule(["Account", "Other"]);
          // setUserType(null);
          setprojectRoleObject({
            RoleId: "",
            UserId: "",
            UserType: "",
            RoleName: "",
            UserName: "",
            ROWID: "",
          });
          setEditIndex(null);
        }
      })
      .catch((e) => {
        console.error("API Error:", e);
      });
  };

  const handleUpdate = async () => {
    debugger;
    const roleObject = { ...projectRoleObject };
    handleApiCall(roleObject);
  };

  const handleDelete = async (data) => {
    AwsServerService.CrudServiceHandler({
      method: "DELETE",
      data: { ROWID: data?.ROWID },
      route: "USERROLES",
    })
      .then((res) => {
        message.success("Role Deleted Successfully !");
        setAccountRoleList((prev) => {
          const updated = prev.filter((item) => item.ROWID !== data?.ROWID);
          if (props.module === "deal") {
            props.setRoles(updated);
          }
          return updated;
        });
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const [modalForm, setModalForm] = useState({
    roleName: "",
    description: "",
    email: "",

    contactOwner:null,
    contactType:null,
    account:null,
    firstName:"",
    lastName:"",
    phone:""
  });
  
  const handleCancelModal = () => {
    setModalVisible(false)
    setModalForm({
        roleName: "",
        description: "",
        email: "",
        contactOwner:null,
        contactType:null,
        account:null,
        firstName:"",
        lastName:"",
        phone:""
      });
  }

  const getContactsByModule = async ()=>{debugger
    await ModuleService.GetModuleList("Contacts").then(res=>{
      if(res.data){
        let obj = {};
        res.data.forEach(contact=>{
          if(obj[contact.Contact_Type]){
            obj[contact.Contact_Type].push(contact)
          }else{
            obj[contact.Contact_Type] = [contact]
          }
        })
        AllUsers?.forEach(u=>{
          if(obj["Internal"]){
            obj["Internal"].push({
              id:u.zuid,
              Email:u.email,
              name:u.full_name,
            })
          }else{
            obj["Internal"] = [{
              id:u.zuid,
              Email:u.email,
              name:u.full_name,
            }]
          }
        })
        setAllContacts(obj)
        reduxDispatch(setModuleContacts(obj));
      }
    }).catch(e=>{
      console.error(e);
    })
  }
  
  const handleModalSubmit = async () => {
    try {
      if (modalType === "role") {
        if (!modalForm.roleName) {
          message.error("Role Name is required");
          return;
        }
        const payload = {
          RoleName: modalForm.roleName,
          RoleType: "Account",
          Description: modalForm.description,
        }
        await AwsServerService.CrudServiceHandler({
            method: "POST",
            data: payload,
            route: "ROLES"
        }).then((res) => {
          setRefreshRoles(prev => !prev);
          message.success("Role added successfully");
        })
      } else {
        if (!modalForm.contactType) {
          message.error("contactType is required");
          return;
        }
          
        await AwsServerService.createNewContact(modalForm, localStorage.getItem('token')).then( async (res) =>{
          if(res?.data?.data[0]?.status == "error"){
            message.error("Email Already Exist for another contact...")
            return
          }
          await getContactsByModule();
          message.success("Contact added successfully");
        })
      }

      setModalForm({
        roleName: "",
        description: "",
        email: "",

        contactOwner:null,
        contactType:null,
        account:null,
        firstName:"",
        lastName:"",
        phone:""
      });

      setModalVisible(false);
    } catch (e) {
      console.error(e);
      message.error("Something went wrong", e.message);
    }
  };

  return (
    <>
      <div className="role-assign-account Custom-Input-Wrapper">
        <div className="client-contact-role flex">
          {/* <Row className="Input-Group mb-3 mr-0 ml-0">
            <Col>
              <span className="labeltext">Select Role Type</span>
              <Select
                rootClassName="select-user-type"
                placeholder={"Select User Type"}
                value={UserType}
                style={{ width: "100%", height: "auto" }}
                onChange={(e) => {
                  onUserTypeChange(e);
                }}
                status={ErrorStatus?.roleTypeError ? "error" : ""}
              >
                {[...(RoleTypeList || [])]
                  .sort((a, b) =>
                    a.roleType_Name.localeCompare(b.roleType_Name),
                  )
                  .map((roleType, i) => (
                    <Select.Option
                      key={roleType.roleType_Name}
                      value={roleType.roleType_value}
                      label={roleType.roleType_Name}
                      children={roleType.roleType_Name}
                      icon={<></>}
                    />
                  ))}
              </Select>
            </Col>
          </Row> */}
          {/* {(change || UserType == "Account" ||
            UserType == "Vendor" ||
            UserType == "Deal") &&
            !TypeOpDropdown && (
              <Row className="Input-Group mb-3 mr-0 ml-0">
                <Col>
                  <span className="labeltext">Select {UserType}</span>
                  <Select
                    showSearch
                    searchValue={searchValue1}
                    status={ErrorStatus?.DealAndClientError ? "error" : ""}
                    placeholder={`Select ${UserType}`}
                    value={projectRoleObject.ProjectId}
                    style={{ width: "100%", height: "auto" }}
                    onChange={(e) => {
                      onDealChange(e);
                    }}
                    dropdownRender={(menu) => (
                      <div>
                        {" "}
                        <Input
                          placeholder="Search..."
                          value={searchValue1}
                          onChange={(e) => setSearchValue1(e.target.value)}
                          autoFocus
                          style={{ marginBottom: 8, width: "100%" }}
                        />
                        {menu}
                      </div>
                    )}
                  >
                    {getAssociatDropdown()}
                  </Select>{" "}
                </Col>
              </Row>
            )} */}
          <Row className="Input-Group mb-3 mr-0 ml-0">
            <Col>
              <span className="labeltext">Select Role</span>
              <RoleUserPicker
                key={1}
                placeholder={"Select Role"}
                onChange={onRoleChange}
                filter={"Account"}
                groupFromProps={["Roles"]}
                value={
                  projectRoleObject["RoleId"]
                    ? "Roles_" + projectRoleObject["RoleId"]
                    : null
                }
                isRole={true}
                ErrorStatus={ErrorStatus?.roleError ? "error" : ""}
                onAddNewRole={() => {
                  setModalType("role");
                  setModalVisible(true);
                }}
                refreshRoles={refreshRoles}
              />
            </Col>
          </Row>
          <Row className="Input-Group mb-3 mr-0 ml-0">
            <Col>
              <span className="labeltext">Select {UserType} Role Assignee</span>
              <HierarchicalDropdown
                accountClassName={"select-role-assignee"}
                GroupName={userListModules}
                filter={
                  UserType != "Deal" ? projectRoleObject["ProjectId"] : null
                }
                handleChangeUser={onUserChange}
                selectedUsers={projectRoleObject["UserId"]}
                placeholder={
                  UserType
                    ? `Select ${UserType} Role Assignee`
                    : "Select Assignee"
                }
                ErrorStatus={ErrorStatus.userError ? "error" : ""}
                clearSearchValue={clearSearchValue}
                setclearSearchValue={setclearSearchValue}
                onAddNewContact={() => {
                  setModalType("contact");
                  setModalVisible(true);
                }}
              />
            </Col>
          </Row>
          <Row
            className="Button-Group-Class mr-0 ml-0 d-flex"
            style={{ flexWrap: "nowrap" }}
          >
            {ErrorStatus?.DealAndClientError ||
            ErrorStatus?.roleError ||
            ErrorStatus?.roleTypeError ||
            ErrorStatus?.userError ? (
              <div className="error-text" style={{ width: "79%" }}>
                Please select All fields
              </div>
            ) : (
              ""
            )}
            <Button
              style={{ width: "auto", padding: "7px" }}
              onClick={() => {
                ClearAllData();
              }}
            >
              Clear
            </Button>
            <Button
              style={{ width: "auto", padding: "7px" }}
              type="primary"
              onClick={() => {
                debugger;
                if (editIndex !== null) {
                  handleUpdate();
                } else {
                  onAdd();
                }
              }}
            >
              {editIndex !== null ? "Save" : "Add"}
            </Button>
          </Row>
        </div>
        <div
          className="account-role-table-wrapper"
          style={{ marginTop: "20px" }}
        >
          <div className="table-scroll">
            <table
              className="ant-table ant-table-bordered"
              style={{ minWidth: "700px" }}
            >
              <thead className="ant-table-thead">
                <tr>
                  <th style={{ width: "80px" }}>Sr No</th>
                  <th style={{ width: "120px" }}>Role Type</th>
                  <th style={{ width: "125px" }}>Role</th>
                  <th style={{ width: "200px" }}>User / Assignee</th>
                  <th style={{ width: "120px" }}>Action</th>
                </tr>
              </thead>
              <tbody className="ant-table-tbody">
                {accountRoleList.length === 0 ? (
                  <tr className="ant-table-placeholder">
                    <td colSpan={5} className="text-center">
                      No data available
                    </td>
                  </tr>
                ) : (
                  accountRoleList.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.UserType}</td>
                      <td>{item.RoleName || item.RoleId}</td>
                      <td>{item.UserName || item.UserId}</td>
                      <td>
                        {isEdit && (
                          <Button
                            style={{ height: "auto", marginRight: "5px" }}
                            onClick={() => {
                              debugger;
                              setEditIndex(index);
                              // setUserType(item.UserType);
                              setUserListModule(["Account"]);
                              setprojectRoleObject({
                                RoleId: item.RoleId,
                                UserId: item.UserId,
                                UserType: item.UserType,
                                RoleName: item.RoleName,
                                UserName: item.UserName,
                                ROWID: item.ROWID,
                                ProjectId: item.ProjectId,
                              });
                            }}
                          >
                            <FontAwesomeIcon icon={faPencilAlt} />
                          </Button>
                        )}
                        {(location.state.action != "Create" && location.state.module != "Deals") &&(
                        <Button
                          danger
                          style={{ height: "auto" }}
                          onClick={() => {
                            if (isEdit) {
                              handleDelete(item);
                            } else {
                              setAccountRoleList((prev) => {
                                const next = prev.filter((_, i) => i !== index);
                                if (props.module === "deal") {
                                  props.setRoles(next);
                                }
                                return next;
                              });
                            }
                          }}
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </Button>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Modal
        title={modalType === "role" ? "Add Role" : "Add Contact"}
        open={modalVisible}
        onCancel={() => handleCancelModal()}
        onOk={() => handleModalSubmit()}
        okText={modalType === "role" ? "Add Role" : "Add Contact"}
      >
        {modalType === "role" ? (
          <div>
            <Row gutter={16} style={{ marginBottom: "20px" }}>
              <Col span={12}>
                <div className="input-wrapper">
                  <span className="floating-label">Role Name</span>
                  <Input placeholder="Enter Role Name" 
                    value={modalForm.roleName}
                    onChange={(e) =>
                      setModalForm({ ...modalForm, roleName: e.target.value })
                    }
                  />
                </div>
              </Col>

              <Col span={12}>
                <div className="input-wrapper">
                  <span className="floating-label">Role Type</span>
                  <Input value={"Account"} readOnly />
                </div>
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <div className="input-wrapper">
                  <span className="floating-label">Description</span>
                  <Input.TextArea
                    placeholder="Enter Description"
                    rows={4}
                    value={modalForm.description}
                    onChange={(e) =>
                      setModalForm({ ...modalForm, description: e.target.value })
                    }
                  />
                </div>
              </Col>
            </Row>
          </div>
        ) : (
          <div>
            <Row gutter={16} style={{ marginBottom: "20px" }}>
              <Col span={12}>
                <div className="input-wrapper">
                <span className="floating-label">Contact Owner</span>

                <Select
                  placeholder="Select Contact Owner"
                  value={modalForm.contactOwner}
                  onChange={(value) =>
                    setModalForm({ ...modalForm, contactOwner: value })
                  }
                  style={{ width: "100%" }}
                  showSearch
                  optionFilterProp="label"
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase().includes(input.toLowerCase())
                  }
                  options={
                    AllUsers?.map((user) => ({
                      label: user?.full_name,
                      value: user?.id,
                    })) || []
                  }
                />
              </div>
              </Col>
               <Col span={12}>
                <div className="input-wrapper">
                  <span className="floating-label">Contact Type</span>

                  <Select
                    placeholder="Select Contact Type"
                    value={modalForm.contactType}
                    onChange={(value) =>
                      setModalForm({ ...modalForm, contactType: value })
                    }
                    style={{ width: "100%" }}
                    options={[
                      { label: "Account", value: "Account" },
                      // { label: "Vendor", value: "Vendor" },
                      { label: "Other", value: "Other" },
                    ]}
                  />
                </div>
              </Col>
            </Row>

            <Row gutter={16} style={{ marginBottom: "20px" }}>
              <Col span={12}>
                <div className="input-wrapper">
                  <span className="floating-label">First Name</span>
                  <Input placeholder="First Name" 
                    value={modalForm.firstName}
                    onChange={(e) =>
                      setModalForm({ ...modalForm, firstName: e.target.value })
                    }
                  />
                </div>
              </Col>
              <Col span={12}>
                <div className="input-wrapper">
                  <span className="floating-label">Last Name</span>
                  <Input placeholder="Last Name" 
                    value={modalForm.lastName}
                    onChange={(e) =>
                      setModalForm({ ...modalForm, lastName: e.target.value })
                    }
                  />
                </div>
              </Col>
            </Row>

            <Row gutter={16} style={{ marginBottom: "20px" }}>
              <Col span={12}>
                <div className="input-wrapper">
                  <span className="floating-label">Email</span>
                  <Input placeholder="Email" 
                    value={modalForm.email}
                    onChange={(e) =>
                      setModalForm({ ...modalForm, email: e.target.value })
                    }
                  />
                </div>
              </Col>
               <Col span={12}>
                <div className="input-wrapper">
                  <span className="floating-label">Phone</span>
                  <Input placeholder="Phone" 
                    value={modalForm.phone}
                    onChange={(e) =>
                      setModalForm({ ...modalForm, phone: e.target.value })
                    }
                  />
                </div>
              </Col>             
            </Row>
            {modalForm.contactType && modalForm.contactType == "Account" && (
              <Row gutter={16} style={{ marginBottom: "20px" }}>
                <Col span={12}>
                  <div className="input-wrapper">
                    <span className="floating-label">Account</span>

                    <Select
                      placeholder="Select Account"
                      value={modalForm.account}
                      onChange={(value) =>
                        setModalForm({ ...modalForm, account: value })
                      }
                      style={{ width: "100%" }}
                      options={
                        allAccounts?.map(acc => ({
                          label: acc.Account_Name || acc.name, 
                          value: acc.id
                        })) || []
                      }
                    />
                  </div>
                </Col>           
              </Row>
            )}
            
          </div>
        )}
      </Modal>
    </>
  );
}
